import { render, staticRenderFns } from "./MapaStatusComercialCidade.vue?vue&type=template&id=a90a62c4"
import script from "./MapaStatusComercialCidade.vue?vue&type=script&lang=js"
export * from "./MapaStatusComercialCidade.vue?vue&type=script&lang=js"
import style0 from "./MapaStatusComercialCidade.vue?vue&type=style&index=0&id=a90a62c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports